// src/components/ParentView.js - Trang chủ Tra cứu cho Phụ huynh dùng Firestore
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { firestore } from '../firebaseConfig';
import { doc, getDoc } from 'firebase/firestore';
import QRScannerOfParent from './QRScannerOfParent';
import StudentClassLookup from './StudentClassLookup'; // ⚡ 1. Import công cụ tra cứu mới
import './ParentView.css';

// ⚡ Đổi thành false khi muốn đóng chức năng tra cứu lớp & phòng học
const SHOW_CLASS_LOOKUP = true;

const ParentView = () => {
  const [studentId, setStudentId] = useState('');
  const [showScanner, setShowScanner] = useState(false);
  const [isSearching, setIsSearching] = useState(false);
  const [errorMsg, setErrorMsg] = useState('');
  const [recentStudents, setRecentStudents] = useState([]);
  
  const navigate = useNavigate();

  // Tải danh sách con em đã từng tra cứu từ localStorage
  useEffect(() => {
    try {
      const saved = JSON.parse(localStorage.getItem('savedParentStudents') || '[]');
      setRecentStudents(saved);
    } catch (e) {}
  }, []);

  const handleIdSubmit = async (e) => {
    e.preventDefault();
    const cleanId = studentId.trim().toUpperCase();

    if (!cleanId) {
      setErrorMsg('Vui lòng nhập mã ID thiếu nhi!');
      return;
    }

    setIsSearching(true);
    setErrorMsg('');

    try {
      const studentSnap = await getDoc(doc(firestore, 'students', cleanId));
      if (studentSnap.exists()) {
        navigate(`/parent/student/${cleanId}`);
      } else {
        setErrorMsg('Không tìm thấy thiếu nhi với mã ID này. Vui lòng kiểm tra lại!');
      }
    } catch (err) {
      setErrorMsg('Lỗi kết nối. Vui lòng thử lại sau!');
    } finally {
      setIsSearching(false);
    }
  };

  const handleQRScanned = (result) => {
    if (result) {
      setShowScanner(false);
      navigate(`/parent/student/${result.trim().toUpperCase()}`);
    }
  };

  return (
    <div className="pv-wrapper">
      <div className="pv-card">
        {/* Header */}
        <div className="pv-header">
          <img src="/logo.png" alt="Logo" className="pv-logo" />
          <h2>Tra Cứu Thông Tin Thiếu Nhi</h2>
          <p>Giáo Xứ An Nhơn – Ban Giáo Lý</p>
        </div>

        {/* ⚡ 2. SECTION TRA CỨU LỚP & PHÒNG HỌC (ĐẶT PHÍA TRÊN SECTION TRA CỨU BẰNG ID) */}
        {SHOW_CLASS_LOOKUP && <StudentClassLookup />}

        {/* Ô Tra Cứu Mã ID */}
        <form onSubmit={handleIdSubmit} className="pv-search-form">
          <input
            type="text"
            value={studentId}
            onChange={(e) => setStudentId(e.target.value.toUpperCase())}
            placeholder="Nhập ID Thiếu Nhi"
            className="pv-input"
            maxLength={15}
          />
          <button type="submit" className="pv-search-btn" disabled={isSearching}>
            {isSearching ? '⏳ Đang tìm...' : '🔍 Tra cứu'}
          </button>
        </form>

        {errorMsg && <p className="pv-error">{errorMsg}</p>}

        {/* Nút Mở Quét Mã QR */}
        <div className="pv-qr-box">
          <button
            type="button"
            onClick={() => setShowScanner(!showScanner)}
            className="pv-qr-btn"
          >
            {showScanner ? '✕ Đóng máy quét' : '📷 Quét Mã QR Thẻ Thiếu Nhi'}
          </button>

          {showScanner && (
            <div className="pv-scanner-modal">
              <QRScannerOfParent onScan={handleQRScanned} />
            </div>
          )}
        </div>

        {/* Danh sách Con Em Tra Cứu Gần Đây */}
        {recentStudents.length > 0 && (
          <div className="pv-recent-section">
            <h3>👶 Con Em Đã Tra Cứu Gần Đây</h3>
            <div className="pv-recent-list">
              {recentStudents.map((st) => (
                <div
                  key={st.id}
                  className="pv-recent-item"
                  onClick={() => navigate(`/parent/student/${st.id}`)}
                >
                  <div className="recent-info">
                    <strong>{st.holyName || ''} {st.fullName}</strong>
                    <span>Mã ID: {st.id} • {st.className}</span>
                  </div>
                  <span className="arrow-icon">→</span>
                </div>
              ))}
            </div>
          </div>
        )}

        {/* Thao tác quay về */}
        <div className="pv-footer">
          <button onClick={() => navigate('/')} className="pv-home-btn">
            🏠 Về Trang Chủ
          </button>
        </div>
      </div>
    </div>
  );
};

export default ParentView;